export default __webpack_public_path__ + "static/media/RAMADAN_WEBSITE_POP_UP.c46214b3.png";